import type { ComboboxListProps } from './ComboboxList'
import ComboboxList from './ComboboxList'

export type VirtualizedComboboxListProps<T> = Omit<ComboboxListProps<T>, 'virtualized'>

export default function VirtualizedComboboxList<T extends object>(
  props: VirtualizedComboboxListProps<T>,
) {
  return <ComboboxList {...props} virtualized />
}
